<div>
  <app-container-job-search-form></app-container-job-search-form>

  @if(userType !== null && isSubUser()){
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    [destroyOnHide]="true"
    class="nav-tabs"
  >
    <li [ngbNavItem]="1">
      <button ngbNavLink>Container Legs</button>
      <ng-template ngbNavContent>
        <app-container-job-leg-status></app-container-job-leg-status>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <button ngbNavLink>Container Job</button>
      <ng-template ngbNavContent>
        <app-container-job-item-status></app-container-job-item-status>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>
  }

  @if (userType !== null && isFreightUser()){
  <app-container-job-item-status></app-container-job-item-status>
  }
</div>